module.exports = __webpack_public_path__ + "assets/img/cloud2.bfc2e105.png";